import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'ikp-ummeldung-edit-inputs-button',
  imports: [TranslatePipe],
  templateUrl: './edit-inputs-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditInputsButtonComponent {
  readonly dataTest = input.required<string>();
}
